import { render, staticRenderFns } from "./refresh-button.vue?vue&type=template&id=143feafa"
import script from "./refresh-button.vue?vue&type=script&lang=js"
export * from "./refresh-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143feafa')) {
      api.createRecord('143feafa', component.options)
    } else {
      api.reload('143feafa', component.options)
    }
    module.hot.accept("./refresh-button.vue?vue&type=template&id=143feafa", function () {
      api.rerender('143feafa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/refresh-button.vue"
export default component.exports